export var dateNow=function(){var precision=arguments.length>0&&arguments[0]!==void 0?arguments[0]:1e3;return Math.floor(Date.now()/precision)*precision};
//# sourceMappingURL=dateNow.js.map